import { createAction, props } from '@ngrx/store';
import { Product } from '../../shared/interfaces/product.interface';

export const getProducts = createAction('[auth] GET_PRODUCTS', props<{company}>());
export const getProductsSuccess = createAction('[auth] GET_PRODUCTS_SUCCESS', props<{ products: Product[] }>());
export const getProductsFail = createAction('[auth] GET_PRODUCTS_FAIL', props<{ error: Error }>());
